import { Location } from "@/api/opb/opbTypes";
import { usesACH, usesBacs, usesPad, usesSepa } from "@/utils/location";

export function bankTransferType(accountLocation: Location | undefined) {
  const shouldShowACH = usesACH(accountLocation);
  const shouldShowPad = usesPad(accountLocation);
  const shouldShowBacs = usesBacs(accountLocation);
  const shouldShowSepa = usesSepa(accountLocation);

  let bankTransfer = "";

  if (shouldShowACH) {
    bankTransfer = "ACH";
  } else if (shouldShowBacs) {
    bankTransfer = "BACS/SEPA";
  } else if (shouldShowSepa) {
    bankTransfer = "SEPA";
  } else if (shouldShowPad) {
    bankTransfer = "PAD";
  } else {
    bankTransfer = "bank account";
  }
  return bankTransfer;
}
